import { render } from "./EditAddress.vue?vue&type=template&id=473aebc4"
import script from "./EditAddress.vue?vue&type=script&lang=js"
export * from "./EditAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__